<div class="item-selector">
  <swiper (indexChange)="changeIndex($event)" [config]="swiperConfig">
    <div *ngFor="let item of items">
      <div *ngIf="hasTransmisProp" class="circle" [class.red-button]="!item.transmis" [class.green-button]="item.transmis"></div>
      <span>{{item[propName]}}</span>
    </div>
  </swiper>
</div>
